import axios from "axios";
import { exploreInternshipRoute } from "../common/endpoints";

export const exploreAllInternships = async () => {
  const config = {
    method: "get",
    url: exploreInternshipRoute,
  };

  try {
    const response = await axios(config);
    return response.data.data;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
